import { z } from 'zod'

import { surveyGroupFilterGroupsSchema } from '~/utils'

export const schema = z.object({
  filterGroups: surveyGroupFilterGroupsSchema,
})
export type InputValues = z.infer<typeof schema>
